import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import resources tĩnh
import en from "./en";
import vi from "./vi";

// đọc/lưu trực tiếp "en" | "vi" trong localStorage
const STORAGE_KEY = "lang";
let lng = localStorage.getItem(STORAGE_KEY);
if (lng !== "en" && lng !== "vi") {
  lng = "en";
  localStorage.setItem(STORAGE_KEY, lng);
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi }
    },
    lng,                
    fallbackLng: "en",  
    supportedLngs: ["en", "vi"],
    interpolation: { escapeValue: false }, 
    returnEmptyString: false              
  });

export default i18n;
